
<script>
  let { ...rest } = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="250"
  height="181"
  viewBox="0 0 250 181"
  {...rest}
>
  <rect
    y="34.5001"
    width="250"
    height="146"
    rx="4"
    stroke="currentColor"
    stroke-width="10"
    fill="none"
  />
  <line x1="27" y1="62.0001" x2="77" y2="62.0001" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="77.8888" x2="77" y2="77.8888" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="97.4454" x2="221" y2="97.4454" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="114.555" x2="221" y2="114.555" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="132.889" x2="221" y2="132.889" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="150" x2="221" y2="150" stroke="currentColor" stroke-width="5" />
  <line
    x1="247.5"
    y1="43.0001"
    x2="247.5"
    y2="13.0001"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
  <path
    d="M185 12.5001L247 12.5001"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
  <line
    x1="204.09"
    y1="36.6095"
    x2="181.698"
    y2="10.0228"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
  <path
    d="M125 9.50012L181 9.50012"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
  <path
    d="M144.305 35.2579L120.095 6.56679"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
  <path
    d="M120 6.50037L64 6.50037"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
  <path
    d="M87.1957 36.1024L59 2.50008"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
  <path
    d="M59 2.50037L3 2.50037"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
  <path
    d="M2.5 38.5001L2.5 3.00012"
    stroke="currentColor"
    stroke-width="5"
    stroke-linecap="round"
  />
</svg>
